import { useEffect, useRef } from 'react';

// Background audio URL - LOCKED
const AUDIO_URL = 'https://customer-assets.emergentagent.com/job_0bb5453a-baec-4203-8db8-6150bde50842/artifacts/0ealnnoy_vaulten.mp3';

/**
 * Hook to play subtle background audio during exercises
 * Volume is intentionally very low - barely audible even at full system volume
 */
export const useBackgroundAudio = (isActive = true) => {
  const audioRef = useRef(null);

  useEffect(() => {
    if (!isActive) return;

    // Create audio element
    const audio = new Audio(AUDIO_URL);
    audio.loop = true;
    audio.volume = 0.005; // Extremely subtle - barely audible even at max system volume
    audioRef.current = audio;

    // Attempt to play (may be blocked by autoplay policies)
    const playAudio = async () => {
      try {
        await audio.play();
      } catch (err) {
        // Autoplay blocked - will start on first user interaction
        const startOnInteraction = () => {
          audio.play().catch(() => {});
          document.removeEventListener('click', startOnInteraction);
          document.removeEventListener('touchstart', startOnInteraction);
        };
        document.addEventListener('click', startOnInteraction);
        document.addEventListener('touchstart', startOnInteraction);
      }
    };

    playAudio();

    // Cleanup
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.src = '';
        audioRef.current = null;
      }
    };
  }, [isActive]);

  return audioRef;
};

export default useBackgroundAudio;
